import React, { useState } from 'react';
import { MessageSquare, Phone, Mail, RefreshCw, Plus, Calendar } from 'lucide-react';
import { Interaction } from '../../types/lead';
import { BookingModal } from '../booking/BookingModal';
interface LeadTimelineProps {
  interactions: Interaction[];
}
export function LeadTimeline({
  interactions
}: LeadTimelineProps) {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const getIcon = (type: Interaction['type']) => {
    switch (type) {
      case 'WA':
        return <MessageSquare className="w-4 h-4 text-growthly-white" data-id="element-482" />;
      case 'Call':
        return <Phone className="w-4 h-4 text-growthly-white" data-id="element-483" />;
      case 'Email':
        return <Mail className="w-4 h-4 text-growthly-white" data-id="element-484" />;
      case 'StateChange':
        return <RefreshCw className="w-4 h-4 text-growthly-white" data-id="element-485" />;
      default:
        return <MessageSquare className="w-4 h-4 text-growthly-white" data-id="element-486" />;
    }
  };
  const getColor = (type: Interaction['type']) => {
    switch (type) {
      case 'WA':
        return 'bg-green-500';
      case 'Call':
        return 'bg-blue-500';
      case 'Email':
        return 'bg-purple-500';
      case 'StateChange':
        return 'bg-growthly-black';
      default:
        return 'bg-growthly-medium';
    }
  };
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  return <div className="card p-5 h-full flex flex-col" data-id="element-487">
      <div className="mb-6" data-id="element-488">
        <h3 className="text-[14px] font-semibold text-growthly-text mb-3" data-id="element-489">
          Próxima Acción
        </h3>
        <div className="bg-growthly-panel border border-white/5 rounded-md p-3 flex items-start" data-id="element-490">
          <Calendar className="w-5 h-5 text-growthly-text mr-3 flex-shrink-0 mt-0.5" data-id="element-491" />
          <div data-id="element-492">
            <p className="text-[13px] font-medium text-growthly-text" data-id="element-493">
              Enviar Propuesta Visual
            </p>
            <p className="text-[11px] text-growthly-muted mt-1" data-id="element-494">
              Vence: Mañana, 10:00
            </p>
            <div className="mt-3 flex space-x-2" data-id="element-495">
              <button onClick={() => setIsBookingOpen(true)} className="text-[11px] font-medium text-growthly-bg bg-growthly-text rounded px-3 py-1.5 hover:bg-growthly-text-2 transition-colors" data-id="element-496">
                Agendar
              </button>
              <button className="text-[11px] font-medium text-growthly-text border border-white/20 rounded px-3 py-1.5 hover:bg-white/10 transition-colors" data-id="element-497">
                Completar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between mb-4" data-id="element-498">
        <h3 className="text-sm font-semibold text-growthly-black" data-id="element-499">Historial</h3>
        <button className="text-xs font-medium text-growthly-black hover:underline flex items-center" data-id="element-500">
          <Plus className="w-3 h-3 mr-1" data-id="element-501" /> Nota
        </button>
      </div>

      <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar" data-id="element-502">
        <div className="relative border-l border-growthly-light ml-3 space-y-6 pb-4" data-id="element-503">
          {interactions.map(interaction => <div key={interaction.id} className="relative pl-6" data-id="element-504">
              <div className={`absolute -left-3 top-0 w-6 h-6 rounded-full flex items-center justify-center ${getColor(interaction.type)} ring-4 ring-growthly-white`} data-id="element-505">
                {getIcon(interaction.type)}
              </div>
              <div data-id="element-506">
                <div className="flex items-center justify-between mb-1" data-id="element-507">
                  <span className="text-xs font-medium text-growthly-black" data-id="element-508">
                    {interaction.type === 'StateChange' ? 'Cambio de estado' : interaction.type}
                  </span>
                  <span className="text-[10px] text-growthly-medium" data-id="element-509">
                    {formatDate(interaction.timestamp)}
                  </span>
                </div>
                <div className="text-sm text-growthly-medium bg-growthly-light/20 p-2 rounded border border-growthly-light/50" data-id="element-510">
                  {interaction.content}
                </div>
              </div>
            </div>)}
        </div>
      </div>

      <div className="pt-4 mt-auto border-t border-growthly-light" data-id="element-511">
        <div className="relative" data-id="element-512">
          <input type="text" placeholder="Añadir nota rápida... (Enter para guardar)" className="w-full text-sm border border-growthly-light rounded-md pl-3 pr-10 py-2 focus:ring-1 focus:ring-growthly-black focus:border-growthly-black" data-id="element-513" />
          <button className="absolute right-2 top-1/2 transform -translate-y-1/2 text-growthly-muted hover:text-growthly-text" data-id="element-514">
            <Plus className="w-4 h-4" data-id="element-515" />
          </button>
        </div>
      </div>

      <BookingModal isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} data-id="element-516" />
    </div>;
}